<template>
    <div class="container mortgage-calculator" :class="calculatorName">

		<div class="row justify-content-center calculator-header">
			<CalculatorHeader>
				<h2>Right to Buy Discount Calculator</h2>
				<h5>NO CREDIT CHECKS!</h5>
				<h5>Fill out the few details below to see how we could help you achieve a mortgage</h5>
			</CalculatorHeader>
		</div>
		<div class="row justify-content-center calculator-body">
			<div class="col-md-10 col-xl-8">
				<form class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

						<transition name="fade-x" mode="out-in">
							<InputElement
								fieldText="What is the current value of your property?"
							>
							<InputTypeNumber currencyPlaceholder v-model="propertyValue"/>
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mb-5" v-if="propertyValue > 0">
							<div class="col-md-6 col-lg-4">Type of home</div>
							<div class="col-md-6 col-lg-8">
								<DropdownMenu :dropdownOptions="dropdownOptions" v-model="propertyType"/>
							</div>
							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mb-5" v-if="propertyValue > 0 && propertyType !== ''">
							<div class="col-md-6 col-lg-4">Where is your property located?</div>
							<div class="col-md-6 col-lg-8">
								<DropdownMenu :dropdownOptions="dropdownOptionsRegions" v-model="region"/>
							</div>
							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'eastern'"
								id="watfordResident"
								text="Do you live in the district of Watford? (Leave Blank if no)"
								v-model="watfordResident"
								:class="{ checked: watfordResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'southeast'"
								id="seResident"
								text="Do you live in the any of the following: Chiltern, Epsom & Ewell, Hart, Oxford, Reading, Reigate & Banstead, Tonbridge & Malling, Vale of the White Horse and West Berkshire? (Leave Blank if no)"
								v-model="seResident"
								:class="{ checked: seResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<CheckBox
								v-if="propertyValue > 0 && propertyType !== '' && region === 'london'"
								id="londonResident"
								text="Do you live in the boroughs of Barking and Dagenham and Havering? (Leave Blank if no)"
								v-model="londonResident"
								:class="{ checked: londonResident }"
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div
								v-if="propertyValue > 0 && propertyType !== ''"
								class="mb-5"
							>
							<InputElement
								fieldText="How many years have you been a tenant?"
							>
								<input class="form-control" type="text" v-model="years">
							</InputElement>

							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row mt-5" v-if="propertyValue > 0 && propertyType !=='' && years > 0">
								<div class="col-md-6 col-lg-4 fw-bold">Why are you using the calculator today</div>
								<div class="col-md-6 col-lg-8 fcs-grid-long">
									<DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1">
								</div>
							</div>
						</transition>   

						<transition name="fade-x" mode="out-in">
							<div class="row mt-5 mb-5" v-if="propertyValue > 0 && propertyType !=='' && years > 0">
								<div class="col-md-6 col-lg-4 fw-bold">When will you be ready to move forward?</div>
								<div class="col-md-6 col-lg-8 fcs-grid-long">
									<DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2">
								</div>
							</div>
						</transition>
						
						<!-- <h4 class="calc-fieldset-title">Applicant Details</h4>

						<BooleanChoiceButtons
							fieldText="Number of applicants"
							buttonTextLeft="1"
							buttonTextRight="2"								
						>
							<template v-slot:left>
								<input type="radio" v-model="applicantsCount" :value="1">										
							</template>
							<template v-slot:right>
								<input type="radio" v-model="applicantsCount" :value="2">										
							</template>																	
						</BooleanChoiceButtons>

						<transition name="fade-x" mode="out-in">
							<InputElement
								v-show="applicantsCount !==0"	
								fieldText="Applicant 1 annual income (including benefits)?"
							>
								<InputTypeNumber currencyPlaceholder v-model="annualIncome1" />
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<InputElement
								v-show="applicantsCount === 2"						
								fieldText="Applicant 2 annual income (including benefits)?"
							>
								<InputTypeNumber currencyPlaceholder v-model="annualIncome2" />
							</InputElement>
						</transition>
						
						<transition name="scale-in" mode="out-in">
							<ReturnedValueBox
								class="mb-5"
								text="Your household income is: "
								:value="householdIncome"
								v-show="annualIncome1 > 0 || annualIncome2 > 0"
								:innerElement=true
							/>
						</transition>

						<transition name="fade-x" mode="out-in">
							<InputElement					
								v-show="annualIncome1 > 0 || annualIncome2 > 0"
								fieldText="Number of dependant children?"
							>
								<InputTypeNumber v-model="dependantChildren" />
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div v-if="showPropertyDetails">
								<h4 class="calc-fieldset-title">Property Details</h4>

								<InputElement					
									fieldText="What is the discounted price?"
								>
									<input class="form-control calc-form-control" type="number" v-model="discountedPrice" min="0">
								</InputElement>						

								<transition name="fade-x" mode="out-in">
									<InputElement
										v-if="discountedPrice"				
										fieldText="Additional deposit, if applicable:"
									>
										<input class="form-control calc-form-control" type="number" v-model="extraDeposit" min="0">
									</InputElement>
								</transition>					
							</div>
						</transition>

						<transition name="fade-x" mode="out-in">
                            <div class="row mt-5" v-if="showCalculateButton">
                                <div class="col-md-6 col-lg-4">Why are you using the calculator today</div>
                                <div class="col-md-6 col-lg-8 fcs-grid-long">
                                    <DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1">
                                </div>
                            </div>
                        </transition>   

                        <transition name="fade-x" mode="out-in">
                            <div class="row mt-5 mb-5" v-if="showCalculateButton">
                                <div class="col-md-6 col-lg-4">When will you be ready to move forward?</div>
                                <div class="col-md-6 col-lg-8 fcs-grid-long">
                                    <DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2">
                                </div>
                            </div>
                        </transition>  -->

						<!-- <transition name="fade-x" mode="out-in">
							<InputElement
								v-if="showListFields"
								fieldText="Name"
							>
								<input class="form-control calc-form-control" type="text" v-model="listName">
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<InputElement
								v-if="showListFields"
								fieldText="Email Address"
							>
								<input class="form-control calc-form-control" type="email" v-model="emailAddress">
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row align-items-center" v-if="showListFields">
								<div class="col-md-1">
									<input type="checkbox" id="privacy" v-model="consent" >
								</div>
								<div class="col-md-11">
									<label for="privacy">I consent to my personal information being processed in accordance with The Mortgage Centres <a href="/cookies-privacy-statement/" target="_blank">Privacy Policy</a></label>
								</div>
							</div>
						</transition> -->

						<transition name="scale-in" mode="out-in">
							<div
								v-if="propertyValue > 0 && propertyType !=='' && years > 0"
								class="text-center mt-5 mb-3"
							>
								<div class="btn calc-btn-secondary" @click="calculate">CALCULATE</div>
							</div>
						</transition>

					</div>							

					<transition name="fade-y" mode="out-in">
						<div v-if="calcCompleted" ref="resultsContainer">

							<ResultsContainer class="mt-5 mb-5 calc-results-box">
								<div class="mb-3 results-title" v-html="this.result"></div>
							</ResultsContainer>

							<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />

						</div>
					</transition>

				</form>
			</div>				
		</div>

    </div>
</template>

<script>
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import axios from "axios"

export default {
	components: {
		CalculatorHeader,
		InputElement,
		InputTypeNumber,
		ResultsContainer,
		DropdownMenu,
		SubmissionForm				
	},	
    data() {
        return {
			calculatorName: 'right-to-buy-discount-calculator',
			propertyValue: 0,
			propertyType: '',
			region: '',
			londonResident: false,
			watfordResident: false,
			seResident: false,
			years: 0,
			dropdownOptions: [
				{ value: '', text: "---- Choose one ----" },
				{ value: 'house', text: "House" },
				{ value: 'flat', text: "Flat" }
			],
			dropdownOptionsRegions: [
				{ value: '', text: "---- Choose one ----" },
				{ value: 'northeast', text: "North East" },
				{ value: 'northwest', text: "North West" },
				{ value: 'yorkshire', text: "Yorkshire and the Humber" },
				{ value: 'eastmidlands', text: "East Midlands" },
				{ value: 'westmidlands', text: "West Midlands" },
				{ value: 'eastern', text: "Eastern" },
				{ value: 'southeast', text: "South East" },
				{ value: 'southwest', text: "South West" },
				{ value: 'london', text: "London" }
			],
			minYears: 3,					//minimum years resident in council property
			maxDiscountPerc: 70,				//maximum percentage
			maxDiscount: '', 			//maximum possible discount
			
			//House settings
			houseDiscountPerc: 35,			//house discount start percentage
			housePercIncreasePerYear: 1, 	//discount percentage per additional year from minimum (house)

			//Flat settings
			flatDiscountPerc: 50,			//Flat discount start percentage
			flatPercIncreasePerYear: 2,	    //discount percentage per additional year from minimum (flat)
			calcCompleted: false,

			result: '',
			calculatedDiscountPerc: 0,
			discountAmount: 0,
			purchaseAmount: 0,
			calculatorReasonTitle: null,
			calculatorReasonResults: null,
			calcReason1: "",
			calcReason2: "",
			listName: "",
			emailAddress: "",
			consent: "",
			dropdownOptionsReason: [
				{value: "Please select an option", text: "Please select an option"},
				{value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
				{
				value: "I'm not ready for a mortgage but am curious about what I could borrow",
				text: "I'm not ready for a mortgage but am curious about what I could borrow"
				},
				{
				value: "I'm starting to save for a house and want to know what to aim for",
				text: "I'm starting to save for a house and want to know what to aim for"
				},
				{
				value: "I need to understand a what I can afford before house shopping",
				text: "I need to understand a what I can afford before house shopping"
				},



			],

			dropdownOptionsMove: [
				{value: "Please select an option", text: "Please select an option"},
				{value: "12+ months", text: "12+ months"},
				{value: "6-12 months", text: "6-12 months"},
				{value: "In the next 3 months", text: "In the next 3 months"},
				{value: "As soon as possible", text: "As soon as possible"},
			],
			submissionReason: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
			submissionList: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
			formErrors: [],
			gfid: 2, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
			gfidlist: 7 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
		}
    },
    methods: {
        calculate() {
			if( this.years < this.minYears ) {
				this.result = `To be eligible for Right to Buy you must have been a council tenant for a minimum of 3 years.`
			} else {

				if (this.region === 'northeast'){
				this.maxDiscount = 22000;
				} else if (this.region === 'northwest') {
				this.maxDiscount = 26000;
				} else if (this.region === 'yorkshire') {
				this.maxDiscount = 24000;
				} else if (this.region === 'eastmidlands') {
				this.maxDiscount = 24000;
				} else if (this.region === 'westmidlands') {
				this.maxDiscount = 26000;
				} else if (this.region === 'eastern') {
				if(this.watfordResident) {
					this.maxDiscount = 16000;
				} else {
					this.maxDiscount = 34000;
				}
				} else if (this.region === 'southeast') {
				if(this.seResident) {
					this.maxDiscount = 16000;
				} else {
					this.maxDiscount = 38000;
				}
				} else if (this.region === 'southwest') {
				this.maxDiscount = 30000;
				} else {
				this.maxDiscount = 16000;
				if(this.londonResident) {
					this.maxDiscount = 38000;
				} else {
					this.maxDiscount = 16000;
				}
				}

				if( this.propertyType === 'house' ) {
				this.calculatedDiscountPerc = this.houseDiscountPerc + ( this.housePercIncreasePerYear * ( this.years - this.minYears ))
				}

				if( this.propertyType === 'flat' ) {
				this.calculatedDiscountPerc = this.flatDiscountPerc + ( this.flatPercIncreasePerYear * ( this.years - this.minYears ))
				}

				//Check if the calculated discount percentage has not breached the maximum discount percentage
				if( this.calculatedDiscountPerc > this.maxDiscountPerc ) {
				this.calculatedDiscountPerc = this.maxDiscountPerc //update discount to maximum discount percentage
				}

				this.discountAmount = ( this.propertyValue / 100 ) * this.calculatedDiscountPerc

				//Check if the calculated discount has not breached the maximum discount
				if( this.discountAmount > this.maxDiscount ) {
				this.discountAmount = this.maxDiscount //update discount to maximum discount
				//recalculate maximum percentage
				this.calculatedDiscountPerc = ( this.discountAmount / this.propertyValue ) * 100
				}

				this.purchaseAmount = ( this.propertyValue - this.discountAmount )
				this.result =
					`
							<p>Discount: ${this.calculatedDiscountPerc.toFixed(0)}%</p>
							<p>Giving a discount of £${this.discountAmount}</p>
							<p>Meaning you could buy your home for £${this.purchaseAmount}</p>
						`

			}
			this.calcCompleted = true;
			this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
			this.calculatorReasonResults = 
			`
			Why are you using the calculator today: ${this.calcReason1}
			When will you be ready to move forward: ${this.calcReason2}
			`;
			this.calculatorListName = this.listName;
			this.calculatorEmailAddress = this.emailAddress;
			this.calculatorConsent = this.consent;
			this.$nextTick(() => {
						const resultsContainer = this.$refs.resultsContainer;

						if (resultsContainer) {
							// Get the bounding rectangle of the element
							const rect = resultsContainer.getBoundingClientRect();

							// Calculate the target scroll position
							const targetScrollPosition = window.scrollY + rect.top - 200;

							// Scroll to the target position
							window.scrollTo({
								top: targetScrollPosition,
								behavior: 'smooth'
							});
						} else {
							console.error('resultsContainer is undefined');
						}
					});
			var newReasonSubmission = new FormData();
			var newListSubmission = new FormData();

			newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
			newReasonSubmission.append("input_1", this.calculatorReasonTitle);
			newReasonSubmission.append("input_3", this.calculatorReasonResults);

			newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
			newListSubmission.append("input_1", this.calculatorListName);
			newListSubmission.append("input_3", this.calculatorEmailAddress);
			newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

			this.postReasonSubmission(newReasonSubmission);
			this.postListSubmission(newListSubmission);
		},
		async postReasonSubmission(submissionReasonData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfid + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionReasonData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submissionReason = response;
                // console.log(submission)

                if ( submissionReason.data.is_valid ) {
                    this.submissionReason.submitted = true;
                    this.submissionReason.is_valid = true;
                }
            } catch(error) {
                // console.log(error)
            }
        },
		async postListSubmission(submissionListData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfidlist + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionListData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submissionList = response;
                // console.log(submission)

                if ( submissionList.data.is_valid ) {
                    this.submissionList.submitted = true;
                    this.submissionList.is_valid = true;
                }
            } catch(error) {
                // console.log(error)
            }
        },
        removeHyphensToUpperCase(str) {
            return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
		},
		resetCalculation() {
			this.calcCompleted = false;
		}				
    },	
    computed: {
		collateMessageBody() {
			let calculatorData = {
				calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
				calculatorResults:
					`
							Property Value: £${parseInt(this.propertyValue)}
				Property Type: £${this.propertyType}
							Where is your property located? ${this.region}
							How long you are the tenant? ${this.years} - years

							Discount: ${this.calculatedDiscountPerc.toFixed(0)}%
							Giving a discount of: £${parseInt(this.discountAmount)}
							Meaning you could buy your home for: £${parseInt(this.purchaseAmount)}
				Why are you using the calculator today: ${this.calcReason1}
				When will you be ready to move forward: ${this.calcReason2}
						`
			}

			return calculatorData;
		}			
    }
}
</script>

<style lang="scss">
	@import './styles/calcs.scss';
</style>